const translations = {
  id: {
    // Header & Navigation
    nav: {
      shop: "Belanja",
      brands: "Merek",
      sign_in: "Masuk",
      my_wishlist: "Wishlist Saya",
      my_orders: "Pesanan Saya",
      admin_dashboard: "Panel Admin",
      logout: "Keluar",
    },
    // Footer
    footer: {
      description: "Fashion modest premium untuk seluruh keluarga. Elegan, nyaman, dan terjangkau.",
      categories: "Kategori",
      company: "Perusahaan",
      our_brands: "Merek Kami",
      shop_all: "Semua Produk",
      support: "Bantuan",
      customer_service: "Layanan Pelanggan",
      shipping_info: "Info Pengiriman",
      returns_exchange: "Retur & Tukar",
      rights_reserved: "Hak Cipta Dilindungi.",
    },
    // Home Page
    home: {
      hero_tag: "Fashion Modest Premium",
      hero_title: "Kelegaan untuk Seluruh Keluarga",
      hero_desc: "Temukan koleksi fashion modest pilihan kami. Produk indah untuk Ibu, Ayah, dan Anak-anak.",
      shop_now: "Belanja Sekarang",
      preorder: "Pre-Order",
      browse_by: "Cari Berdasarkan",
      categories_title: "Kategori",
      limited_time: "Waktu Terbatas",
      preorder_open: "Pre-Order Sedang Dibuka",
      view_all: "Lihat Semua",
      available_now: "Tersedia Sekarang",
      ready_stock: "Stok Siap",
      family_tag: "Untuk Seluruh Keluarga",
      family_title: "Koleksi Keluarga",
      family_desc: "Set seragam untuk ibu, ayah, dan anak-anak. Ciptakan momen indah keluarga dalam busana modest yang terkoordinasi.",
      explore_family: "Jelajahi Set Keluarga",
      trusted: "Terpercaya",
      our_brands: "Merek Kami",
      why_us: "Mengapa Memilih Haniyah Gallery",
      features: {
        quality_title: "Kualitas Terpilih",
        quality_desc: "Setiap produk dipilih berdasarkan kualitas premium dan desain elegan.",
        shipping_title: "Pengiriman Nasional",
        shipping_desc: "Pengiriman andal ke seluruh Indonesia dengan pelacakan.",
        brands_title: "Merek Terpercaya",
        brands_desc: "Bekerja sama dengan merek fashion modest ternama di Indonesia.",
        returns_title: "Mudah Retur",
        returns_desc: "Proses retur tanpa ribet dalam 7 hari setelah pengiriman.",
      }
    },
    // Common
    common: {
      search: "Cari...",
      search_products: "Cari produk...",
      search_brands: "Cari merek...",
      search_product_brand: "Cari Product / Brand",
      products_found: "produk ditemukan",
      filters: "Filter",
      category: "Kategori",
      stock_type: "Tipe Stok",
      brand: "Merek",
      all: "Semua",
      all_brands: "Semua Merek",
      page: "Halaman",
      of: "dari",
      no_products: "Produk tidak ditemukan. Coba sesuaikan filter Anda.",
      no_brands: "Merek tidak ditemukan.",
      loading: "Memuat...",
      back_to_all_brands: "Kembali ke Semua Merek",
      manage_products: "Kelola Produk",
      products: "Produk",
    },
    // Cart Page
    cart: {
      title: "Keranjang Belanja",
      empty: "Keranjang Anda kosong",
      continue_shopping: "Lanjutkan Belanja",
      subtotal: "Subtotal",
      items: "produk",
      checkout: "Lanjut ke Pembayaran",
      variant: {
        size: "Ukuran",
        color: "Warna",
      }
    },
    // Admin Sidebar
    admin_nav: {
      dashboard: "Dasbor",
      orders: "Order",
      shipping: "Shipping",
      products: "Produk",
      customers: "Customer",
      users: "Users",
      discounts: "Diskon",
      finance: "Finance",
      payments: "Payments",
      expense: "Expense",
      tools: "Tools",
      reports: "Reports",
      analytics: "Analytics",
      addons: "Addons",
      label: "Label",
      settings: "Settings",
      brands: "Brands",
      back_to_store: "Kembali ke Toko",
      admin_panel: "Panel Admin",
      master_variants: "Master Varian",
    },
    // Admin Dashboard
    admin_dash: {
      title: "Dashboard",
      stats: {
        products: "Produk",
        orders: "Pesanan",
        users: "Pengguna",
        brands: "Merek",
        revenue: "Pendapatan",
        pending: "Tertunda",
      },
      charts: {
        revenue_30: "Pendapatan (30 Hari Terakhir)",
        orders_30: "Pesanan (30 Hari Terakhir)",
        rev_category: "Pendapatan per Kategori",
        ord_status: "Pesanan per Status",
      },
      top_products: {
        title: "Produk Terlaris",
        product: "Produk",
        qty: "Jumlah Terjual",
        revenue: "Pendapatan",
      },
      recent_orders: {
        title: "Pesanan Terbaru",
        no_orders: "Belum ada pesanan",
      }
    },
    // Checkout Page
    checkout: {
      title: "Pengecekan Akhir",
      shipping_info: "Informasi Pengiriman",
      full_name: "Nama Lengkap",
      phone: "Nomor Telepon",
      address: "Alamat",
      payment_method: "Metode Pembayaran",
      bank_transfer: "Transfer Bank",
      bank_transfer_desc: "Transfer ke rekening bank kami. Pesanan akan diproses setelah konfirmasi pembayaran.",
      summary: "Ringkasan Pesanan",
      place_order: "Buat Pesanan",
      placing_order: "Membuat Pesanan...",
      success_msg: "Pesanan {id} berhasil dibuat!",
      split_notice: "Keranjang Anda mengandung produk Pre-Order dan Ready Stock. Pesanan akan otomatis dibagi menjadi 2 transaksi terpisah.",
      split_success: "Pesanan dibagi: {rs} (Ready Stock) + {po} (Pre-Order).",
    },
    // Admin Products
    admin_products: {
      no_brand_title: "Merek Belum Dipilih",
      no_brand_desc: "Untuk mengelola produk, silakan kembali ke halaman Merek dan pilih merek terlebih dahulu.",
      go_to_brands: "Kembali ke Merek",
      add_product: "Tambah Produk",
      product: "Produk",
      category: "Kategori",
      price: "Harga",
      type: "Tipe",
      actions: "Aksi",
      edit_product: "Edit Produk",
      new_product: "Produk Baru",
      name: "Nama",
      select_category: "Pilih kategori",
      stock_type: "Tipe Stok",
      desc: "Deskripsi",
      price_retail: "Harga Normal Pusat",
      price_reseller: "Harga Reseller",
      closing_date: "Tanggal Tutup",
      delivery_est: "Estimasi Ready",
      images: "Gambar Produk",
      variants_stock: "Varian & Stok",
      style: "Model (Style)",
      select_add_variant: "Pilih / Tambah Varian (Warna)",
      select_variant: "Pilih Varian",
      new_variant_name: "Nama Warna Baru",
      new_btn: "Baru",
      sizes_stock_for: "Ukuran & Stok untuk",
      add_size: "Tambah Ukuran",
      variants_summary: "Ringkasan Varian",
      update_btn: "Perbarui Produk",
      create_btn: "Buat Produk",
      confirm_delete: "Hapus produk ini?",
      deleted: "Dihapus!",
      image_uploaded: "Gambar terunggah!",
      upload_failed: "Gagal unggah",
      select_variant_first: "Pilih varian terlebih dahulu",
      import_excel: "Impor Excel",
      importing: "Mengimpor...",
      import_success: "Berhasil mengimpor {count} produk!",
      import_failed: "Gagal mengimpor produk",
      po_status: "Status PO",
      po_open: "PO Dibuka",
      po_closed: "PO Ditutup",
      po_ready: "Produk Ready",
      po_status_desc: "Tutup PO secara manual (mengabaikan tanggal tutup)",
      filter_brand: "Filter Merek",
      filter_stock_type: "Filter Stok",
      all_stock_types: "Semua Tipe Stok",
    },
    // Admin Orders
    admin_orders: {
      status: "Status",
      update: "Perbarui",
      no_orders: "Tidak ada pesanan",
      total_transactions: "Total Transaksi",
      export_per_product: "Export per Produk",
      search_placeholder_v2: "Cari ID Pesanan / Pelanggan...",
      table: {
        transaction: "Transaksi",
        customer: "Pelanggan",
        total: "Total",
        total_paid: "Total Cicilan",
        status: "Status",
        actions: "Aksi",
      },
      items_count: "{count} produk dibeli",
      modal: {
        customer_info: "Info Pelanggan",
        summary: "Ringkasan",
        date: "Tanggal",
        payment_status: "Status Pembayaran",
        shipping_status: "Status Pengiriman",
        grand_total: "Total Akhir",
        items_purchased: "Produk yang Dibeli",
        installments: "Cicilan / Pembayaran",
        no_payments: "Belum ada pembayaran tercatat.",
        record_payment: "Catat Pembayaran Baru",
        nominal: "Nominal",
        method: "Metode",
        notes: "Catatan (Opsional)",
        add_payment_btn: "Tambah Pembayaran",
        success_add_payment: "Pembayaran berhasil ditambahkan",
        view_proof: "Lihat Bukti",
        customer_notes: "Catatan Pelanggan",
        shipping_settings: "Pengaturan Pengiriman",
        courier: "Kurir",
        awb: "Nomor Resi / AWB",
        shipping_notes: "Catatan Pengiriman",
        save_shipping: "Simpan & Kirim Pesanan",
        shipping_success: "Resi pengiriman berhasil disimpan",
      }
    },
    // Admin Brands
    admin_brands: {
      add_brand: "Tambah Merek",
      no_desc: "Tidak ada deskripsi.",
      manage_products: "Kelola Produk",
      edit_brand: "Edit Merek",
      new_brand: "Merek Baru",
      save_changes: "Simpan Perubahan",
      update_btn: "Perbarui Merek",
      create_btn: "Buat Merek",
    },
    // Admin Rekenings
    admin_rekenings: {
      title: "Manajemen Rekening",
      add_button: "Tambah Rekening",
      bank_name: "Nama Bank",
      account_number: "Nomor Rekening",
      account_holder: "Nama Pemilik",
      status: "Status",
      edit_title: "Edit Rekening",
      new_title: "Rekening Baru",
      placeholder_bank: "BCA / Mandiri / BSI",
      updated: "Rekening diperbarui!",
      created: "Rekening dibuat!",
      update_btn: "Perbarui Rekening",
      create_btn: "Buat Rekening",
    },
    // Admin Customers
    admin_customers: {
      title: "Pelanggan & Mitra",
      add_button: "Tambah Pelanggan",
      no_customers: "Belum ada data pelanggan.",
      name: "Nama",
      type: "Tipe",
      contact: "Kontak",
      status: "Status",
      actions: "Aksi",
      edit_title: "Edit Pelanggan",
      new_title: "Pelanggan Baru",
      phone: "Telepon",
      social_account: "Akun Sosial (IG/Tiktok)",
      address: "Alamat / Kota",
      retail: "Pelanggan (Retail)",
      updated: "Pelanggan diperbarui!",
      created: "Pelanggan dibuat!",
      deleted: "Pelanggan dihapus!",
      update_btn: "Perbarui Pelanggan",
      create_btn: "Buat Pelanggan",
    },
    // Admin Reports
    admin_reports: {
      title: "Laporan & Analitik",
      tabs: {
        po_close: "Laporan Tutup PO",
        omset: "Ringkasan Omset",
        export: "Ekspor Data",
      },
      po_close_title: "Penutupan Pre-Order",
      po_close_desc: "Ringkasan pesanan untuk produk yang tutup pada tanggal tertentu",
      omset_title: "Ringkasan Omset Bulanan",
      omset_desc: "Agregasi pendapatan per bulan",
      export_title: "Ekspor Data",
      export_desc: "Unduh file Excel (.xlsx) komprehensif yang berisi semua transaksi dan detail Pre-Order.",
      download_btn: "Unduh Transaksi PO (Excel)",
      table: {
        product_name: "Nama Produk",
        total_qty: "Total Qty",
        transactions: "Transaksi",
        omset: "Omset",
        month: "Bulan",
        discount: "Diskon",
        grand_total: "Total Akhir",
        type: "Jenis Order",
        preorder: "Pre-Order (PO)",
        ready_stock: "Ready Stock",
      },
      no_data_po: "Tidak ada data tutup PO untuk tanggal ini",
      no_data_omset: "Tidak ada data omset ditemukan untuk tahun {year}",
    },
    // Admin Users
    admin_users: {
      search_placeholder: "Cari berdasarkan nama atau email...",
      user: "Pengguna",
      role: "Peran",
      joined: "Bergabung",
      update_role: "Perbarui Peran",
      no_users: "Tidak ada pengguna",
      actions: "Aksi",
      confirm_delete: "Hapus pengguna ini?",
      deleted: "Pengguna berhasil dihapus",
    },
    // Admin Settings
    admin_settings: {
      config_title: "Konfigurasi White-Label",
      store_name: "Nama Toko",
      primary_color: "Warna Utama",
      secondary_color: "Warna Sekunder",
      store_desc: "Deskripsi Toko",
      save_btn: "Simpan Pengaturan",
      saving: "Menyimpan...",
      rs_timeout: "Batas Waktu Bayar RS (Jam)",
      po_timeout: "Batas Waktu Bayar PO (Jam)",
    },
    // Product Detail
    product_detail: {
      preorder_info: "Informasi PreOrder",
      closing_date: "Tanggal Penutupan",
      delivery_est: "Estimasi Pengiriman",
      size: "Ukuran",
      color: "Warna",
      quantity: "Jumlah",
      in_stock: "stok tersedia",
      add_to_cart: "Tambah ke Keranjang",
      buy_now: "Beli Sekarang",
      reviews: "Ulasan Pelanggan",
      out_of_5: "dari 5",
      write_review: "Tulis Ulasan",
      your_rating: "Rating Anda",
      share_experience: "Bagikan pengalaman Anda dengan produk ini...",
      submit_review: "Kirim Ulasan",
      submitting: "Mengirim...",
      no_reviews: "Belum ada ulasan. Jadilah yang pertama memberikan ulasan!",
      loading: "Memuat produk...",
    },
    // Orders Page
    orders: {
      title: "Pesanan Saya",
      no_orders: "Belum ada pesanan yang dibuat.",
      transaction: "Transaksi",
      status_pending: "Menunggu pembayaran",
      status_paid: "Lunas",
      status_processing: "Menunggu Pengiriman",
      status_shipped: "Proses Pengiriman",
      status_completed: "Selesai",
      status_preorder: "PreOrder",
      status_awaiting_settlement: "Menunggu Pelunasan",
      status_cancelled: "Dibatalkan",
      success_upload: "Bukti pembayaran berhasil diunggah! Status diperbarui menjadi Lunas.",
      upload_proof: "Unggah Bukti Pembayaran",
      upload_desc: "Transfer ke rekening bank kami dan unggah struk pembayarannya",
      uploading: "Mengunggah...",
      upload_btn: "Unggah Struk",
      proof_uploaded: "Bukti pembayaran telah diunggah",
      view_proof: "Lihat",
      cancel_order: "Batalkan Pesanan",
      cancel_confirm: "Apakah Anda yakin ingin membatalkan pesanan ini?",
      cancel_success: "Pesanan berhasil dibatalkan",
      cancelling: "Membatalkan...",
      back_to_list: "Kembali ke Daftar Pesanan",
      not_found: "Pesanan tidak ditemukan.",
      order_id: "Pesanan",
      po_closing_in: "PO ditutup",
      unit_day: "h",
      unit_hour: "j",
      unit_minute: "m",
      unit_second: "d",
      grand_total: "Total Akhir",
      view_detail: "Lihat Detail",
      search_placeholder: "Cari ID pesanan atau produk...",
      sort_by: "Urutkan",
      newest: "Terbaru",
      oldest: "Terlama",
      name_asc: "Nama Produk (A-Z)",
      name_desc: "Nama Produk (Z-A)",
    },
    order_detail: {
      status_title: "Status Pesanan",
      items_title: "Daftar Produk",
      payment_title: "Instruksi Pembayaran",
      shipping_title: "Alamat Pengiriman",
      billing_summary: "Total Belanja",
      paid: "Terbayar",
      remaining: "Sisa Tagihan",
      dp_required: "DP Dibutuhkan",
      po_notice: "Pre-Order: Silakan bayar DP dulu",
      rs_notice: "Segera Lakukan Transfer",
      due_date: "Batas Waktu",
      copy_rek: "Nomor rekening disalin!",
      upload_proof_btn: "Unggah Bukti Transfer",
      uploading: "Mengunggah...",
      proof_sent: "Bukti Terkirim",
      proof_desc: "Terima kasih. Kami telah menerima bukti transfer Anda dan sedang dalam proses verifikasi.",
      view_attachment: "Lihat Lampiran",
      shipping_desc_po: "Sesuai prosedur PO, Anda bisa mengatur alamat dengan santai sekarang tanpa perlu terburu-buru seperti saat checkout! 🥳",
      shipping_update_desc: "Silakan update alamat Anda jika ada perubahan sebelum barang dikirim.",
      recipient_name: "Nama Penerima",
      phone_number: "Nomor HP",
      full_address: "Alamat Lengkap",
      save_address: "Simpan Alamat",
      cancel: "Batal",
      shipped_to: "Dikirim ke",
      edit: "Ubah",
      cancel_order: "Batalkan Pesanan",
      waiting_verification: "Menunggu Verifikasi Admin",
      fill_address: "Lengkapi Alamat Pengiriman",
      order_processing: "Pesanan Diproses",
      confirm_dp: "Konfirmasi Bayar DP",
      confirm_settlement: "Konfirmasi Pelunasan",
      confirm_full: "Konfirmasi Bayar Lunas",
      payment_history: "Riwayat Konfirmasi Pembayaran",
      conf_submitted: "Konfirmasi dikirim, menunggu verifikasi Admin.",
      conf_verified: "Terverifikasi",
      conf_rejected: "Ditolak",
      conf_pending: "Menunggu",
      payment_proof_label: "Bukti Transfer",
      shipping_info: "Lacak Pengiriman",
      courier: "Kurir",
      awb: "Nomor Resi",
      copied: "Tersalin!",
    },
    // Wishlist Page
    wishlist: {
      title: "Wishlist Saya",
      empty: "Wishlist Anda kosong",
      browse: "Lihat Produk",
    },
    // Login/Register Page
    auth: {
      welcome_back: "Selamat Datang Kembali",
      create_account: "Buat Akun",
      sign_in_desc: "Masuk untuk melanjutkan belanja",
      join_today: "Gabung Haniyah Gallery hari ini",
      full_name: "Nama Lengkap",
      email: "Email",
      password: "Kata Sandi",
      account_type: "Tipe Akun",
      retail_customer: "Pelanggan Retail",
      reseller: "Reseller",
      agen: "Agen",
      mitra: "Mitra",
      reseller_agent: "Reseller / Agen",
      sign_in_btn: "Masuk",
      sign_up_btn: "Daftar",
      please_wait: "Mohon tunggu...",
      or: "atau",
      google_continue: "Lanjutkan dengan Google",
      no_account: "Belum punya akun?",
      have_account: "Sudah punya akun?",
      sign_up_link: "Daftar Sekarang",
      sign_in_link: "Masuk Sekarang",
      welcome_msg: "Selamat datang kembali!",
      account_created: "Akun berhasil dibuat!",
    },
    // Product Card
    product_card: {
      login_required: "Silakan masuk untuk menambahkan ke wishlist",
      added: "Ditambahkan ke wishlist",
      removed: "Dihapus dari wishlist",
      reseller: "Reseller",
      closes: "Tutup pada",
    },
    // Notifications
    notifications: {
      title: "Notifikasi",
      mark_all_read: "Tandai semua dibaca",
      no_notifs: "Tidak ada notifikasi",
    },
    // Admin Master Variants
    admin_master: {
      title: "Master Data Varian",
      tab_styles: "Styles",
      tab_colors: "Warna",
      tab_sizes: "Ukuran",
      add_btn: "Tambah",
      adding: "Menambahkan...",
      name: "Nama",
      hex_code: "Kode Warna",
      sort_order: "Urutan",
      confirm_delete: "Hapus item ini?",
      deleted: "Berhasil dihapus",
      added: "Berhasil ditambahkan",
      no_data: "Belum ada data",
      placeholder_style: "Nama style baru...",
      placeholder_color: "Nama warna baru...",
      placeholder_size: "Nama ukuran baru...",
    },
    // Landing Page
    landing: {
      hero_tag: "Haniyah Gallery",
      hero_headline: "Elegansi dalam Setiap Helai",
      hero_desc: "Koleksi busana muslim pilihan dari berbagai brand fashion terpercaya untuk Anda dan keluarga.",
      hero_cta: "Lihat Koleksi",
      hero_cta2: "Gabung Mitra Kami",
      values_tag: "Mengapa Haniyah Gallery",
      values_title: "Partner Fashion yang Amanah",
      value_1_title: "Trusted / Amanah",
      value_1_desc: "Berdiri sejak tahun 2019.",
      value_2_title: "Distributor Multi Brand",
      value_2_desc: "Menjual lebih dari 100 brand fashion.",
      value_3_title: "Packing Rapi & Aman",
      value_3_desc: "Setiap pesanan diproses dengan packaging yang rapi, aman, dan siap dikirim ke customer.",
      value_4_title: "Support Reseller",
      value_4_desc: "Mendukung kebutuhan reseller dan dropshipper dengan produk pilihan serta pengiriman yang terpercaya.",
      brands_tag: "Dipercaya Banyak Brand",
      brands_title: "Partner Brand Kami",
      brands_desc_prefix: "Dipercaya oleh",
      brands_desc_suffix: "brand partner pilihan yang memperkuat kredibilitas dan jangkauan kami.",
      brands_empty: "Daftar brand partner akan tampil di sini setelah data brand tersedia.",
      brands_cta: "Lihat Semua Brand",
      brands_partner_cta: "Gabung Mitra Kami",
      featured_tag: "Pilihan Terbaik",
      featured_title: "Koleksi Unggulan",
      featured_desc: "Produk-produk terpilih yang menjadi favorit pelanggan kami.",
      featured_cta: "Lihat Semua Koleksi",
      featured_fallback_1: "Gamis Sage Premium",
      featured_fallback_2: "Set Couple Elegan",
      featured_fallback_3: "Hijab Voal Exclusive",
      featured_fallback_4: "Family Set Harmoni",
      preorder_tag: "Peluang Reseller",
      preorder_title: "Yuk mulai punya penghasilan sendiri dari rumah…",
      preorder_desc: "Gabung jadi Reseller di Haniyah Gallery 🤍\nTanpa ribet stok banyak, tanpa harus punya toko ✨\nCukup niat, HP, dan semangat belajar jualan 🥰",
      preorder_cta: "Gabung Jadi Reseller",
      preorder_benefit_heading: "Kenapa join di Haniyah Gallery?",
      preorder_benefit_1: "Pendaftaran GRATIS",
      preorder_benefit_2: "Bisa jualan dari rumah",
      preorder_benefit_3: "Free katalog cantik & siap posting",
      preorder_benefit_4: "Free join grup support jualan",
      preorder_benefit_5: "Diskon hingga 30%",
      preorder_benefit_6: "Cashback & reward penjualan",
      preorder_benefit_7: "Menjual 100+ brand fashion muslimah",
      preorder_suitable_heading: "Cocok untuk:",
      preorder_suitable_1: "Ibu rumah tangga",
      preorder_suitable_2: "Mahasiswi",
      preorder_suitable_3: "Karyawan yang cari tambahan penghasilan",
      preorder_suitable_4: "Yang mau mulai usaha pelan-pelan",
      preorder_closing_note: "💌 Pelan-pelan belajar, insyaAllah jadi jalan rezeki",
      reseller_tag: "Peluang Bisnis",
      reseller_title: "Jadilah Mitra Haniyah Gallery",
      reseller_desc: "Bergabunglah dengan jaringan reseller kami dan bangun bisnis fashion muslim Anda sendiri dengan dukungan penuh dari kami.",
      reseller_cta: "Daftar Sebagai Mitra",
      reseller_benefit_1: "Harga reseller kompetitif",
      reseller_benefit_2: "Materi promosi siap pakai",
      reseller_benefit_3: "Support & bimbingan bisnis",
      reseller_benefit_4: "Tanpa minimum order besar",
      packaging_tag: "Pengiriman",
      packaging_title: "Packaging Rapi, Siap Kirim ke Customer",
      packaging_desc: "Setiap pesanan diproses dengan packing yang rapi dan aman.",
      packaging_benefit_1: "Packing aman dan rapi",
      packaging_benefit_2: "Siap support reseller",
      packaging_benefit_3: "Mendukung pengiriman dropship",
      packaging_cta: "Gabung Mitra",
      packaging_main_alt: "Packaging pengiriman Haniyah Gallery yang rapi dan siap dikirim",
      packaging_detail_alt: "Detail paket pengiriman reseller Haniyah Gallery",
      packaging_stack_alt: "Tumpukan paket siap kirim Haniyah Gallery",
      packaging_shipment_alt: "Paket pengiriman Haniyah Gallery siap dikirim",
      testimonial_tag: "Testimoni",
      testimonial_title: "Kata Mereka Tentang Kami",
      testimonial_1_name: "Siti Aminah",
      testimonial_1_loc: "Jakarta",
      testimonial_1_text: "Bahannya adem banget dan jahitannya rapi. Saya sudah repeat order 3 kali. Anak-anak juga suka pakai family set-nya!",
      testimonial_2_name: "Dewi Rahmawati",
      testimonial_2_loc: "Surabaya",
      testimonial_2_text: "Sebagai reseller, saya sangat terbantu dengan support dari Haniyah Gallery. Produknya mudah dijual karena kualitasnya memang bagus.",
      testimonial_3_name: "Nur Fadilah",
      testimonial_3_loc: "Bandung",
      testimonial_3_text: "Desainnya elegan dan nggak pasaran. Cocok untuk acara formal maupun sehari-hari. Pengiriman juga cepat dan aman.",
      closing_title: "Temukan Koleksi Impian Anda",
      closing_desc: "Jelajahi rangkaian busana muslim premium yang dirancang untuk menemani setiap momen istimewa Anda.",
      closing_cta: "Belanja Sekarang",
    }
  },
  en: {
    // Header & Navigation
    nav: {
      shop: "Shop",
      brands: "Brands",
      sign_in: "Sign In",
      my_wishlist: "My Wishlist",
      my_orders: "My Orders",
      admin_dashboard: "Admin Dashboard",
      logout: "Logout",
    },
    // Footer
    footer: {
      description: "Premium modest fashion for the whole family. Elegant, comfortable, and affordable.",
      categories: "Categories",
      company: "Company",
      our_brands: "Our Brands",
      shop_all: "Shop All",
      support: "Support",
      customer_service: "Customer Service",
      shipping_info: "Shipping Info",
      returns_exchange: "Returns & Exchange",
      rights_reserved: "All rights reserved.",
    },
    // Home Page
    home: {
      hero_tag: "Premium Modest Fashion",
      hero_title: "Elegance for the Whole Family",
      hero_desc: "Discover our curated collection of modest fashion. Beautiful pieces for mothers, fathers, and children.",
      shop_now: "Shop Now",
      preorder: "PreOrder",
      browse_by: "Browse by",
      categories_title: "Categories",
      limited_time: "Limited Time",
      preorder_open: "PreOrder Now Open",
      view_all: "View All",
      available_now: "Available Now",
      ready_stock: "Ready Stock",
      family_tag: "For the Whole Family",
      family_title: "Family Collection",
      family_desc: "Matching sets for mom, dad, and the kids. Create beautiful family moments in coordinated modest fashion.",
      explore_family: "Explore Family Sets",
      trusted: "Trusted",
      our_brands: "Our Brands",
      why_us: "Why Choose Haniyah Gallery",
      features: {
        quality_title: "Curated Quality",
        quality_desc: "Every piece is selected for premium quality and elegant design.",
        shipping_title: "Nationwide Shipping",
        shipping_desc: "Reliable delivery across Indonesia with tracking.",
        brands_title: "Trusted Brands",
        brands_desc: "Partner with Indonesia's top modest fashion brands.",
        returns_title: "Easy Returns",
        returns_desc: "Hassle-free returns within 7 days of delivery.",
      }
    },
    // Common
    common: {
      search: "Search...",
      search_products: "Search products...",
      search_brands: "Search brands...",
      search_product_brand: "Search Product / Brand",
      products_found: "products found",
      filters: "Filters",
      category: "Category",
      stock_type: "Stock Type",
      brand: "Brand",
      all: "All",
      all_brands: "All Brands",
      page: "Page",
      of: "of",
      no_products: "No products found. Try adjusting your filters.",
      no_brands: "No brands found.",
      loading: "Loading...",
      back_to_all_brands: "Back to All Brands",
      manage_products: "Manage Products",
      products: "Products",
    },
    // Cart Page
    cart: {
      title: "Shopping Cart",
      empty: "Your cart is empty",
      continue_shopping: "Continue Shopping",
      subtotal: "Subtotal",
      items: "items",
      checkout: "Proceed to Checkout",
      variant: {
        size: "Size",
        color: "Color",
      }
    },
    // Admin Sidebar
    admin_nav: {
      dashboard: "Dashboard",
      orders: "Order",
      shipping: "Shipping",
      products: "Products",
      customers: "Customers",
      users: "Users",
      discounts: "Discounts",
      finance: "Finance",
      payments: "Payments",
      expense: "Expense",
      tools: "Tools",
      reports: "Reports",
      analytics: "Analytics",
      addons: "Addons",
      label: "Label",
      settings: "Settings",
      brands: "Brands",
      back_to_store: "Back to Store",
      admin_panel: "Admin Panel",
      master_variants: "Master Variants",
    },
    // Admin Dashboard
    admin_dash: {
      title: "Dashboard",
      stats: {
        products: "Products",
        orders: "Orders",
        users: "Users",
        brands: "Brands",
        revenue: "Revenue",
        pending: "Pending",
      },
      charts: {
        revenue_30: "Revenue (Last 30 Days)",
        orders_30: "Orders (Last 30 Days)",
        rev_category: "Revenue by Category",
        ord_status: "Orders by Status",
      },
      top_products: {
        title: "Top Products by Revenue",
        product: "Product",
        qty: "Qty Sold",
        revenue: "Revenue",
      },
      recent_orders: {
        title: "Recent Orders",
        no_orders: "No orders yet",
      }
    },
    // Checkout Page
    checkout: {
      title: "Checkout",
      shipping_info: "Shipping Information",
      full_name: "Full Name",
      phone: "Phone Number",
      address: "Address",
      payment_method: "Payment Method",
      bank_transfer: "Bank Transfer",
      bank_transfer_desc: "Transfer to our bank account. Order will be processed after payment confirmation.",
      summary: "Order Summary",
      place_order: "Place Order",
      placing_order: "Placing Order...",
      success_msg: "Order {id} placed successfully!",
      split_notice: "Your cart contains both Pre-Order and Ready Stock items. The order will be automatically split into 2 separate transactions.",
      split_success: "Order split: {rs} (Ready Stock) + {po} (Pre-Order).",
    },
    // Admin Products
    admin_products: {
      no_brand_title: "No Brand Selected",
      no_brand_desc: "To manage products, please return to the Brands page and select a brand first.",
      go_to_brands: "Go to Brands",
      add_product: "Add Product",
      product: "Product",
      category: "Category",
      price: "Price",
      type: "Type",
      actions: "Actions",
      edit_product: "Edit Product",
      new_product: "New Product",
      name: "Name",
      select_category: "Select category",
      stock_type: "Stock Type",
      desc: "Description",
      price_retail: "Central Base Price",
      price_reseller: "Reseller Price",
      closing_date: "Closing Date",
      delivery_est: "Ready Estimate",
      images: "Product Images",
      variants_stock: "Variants & Stock",
      style: "Style",
      select_add_variant: "Select / Add Variant (Color)",
      select_variant: "Select Variant",
      new_variant_name: "New Color Name",
      new_btn: "New",
      sizes_stock_for: "Sizes & Stock for",
      add_size: "Add Size",
      variants_summary: "Variants Summary",
      update_btn: "Update Product",
      create_btn: "Create Product",
      confirm_delete: "Delete this product?",
      deleted: "Deleted!",
      image_uploaded: "Image uploaded!",
      upload_failed: "Upload failed",
      select_variant_first: "Select a variant first",
      import_excel: "Import Excel",
      importing: "Importing...",
      import_success: "Imported {count} products successfully!",
      import_failed: "Failed to import products",
      po_status: "PO Status",
      po_open: "PO Open",
      po_closed: "PO Closed",
      po_ready: "Product Ready",
      po_status_desc: "Close PO manually (ignores closing date)",
      filter_brand: "Filter Brand",
      filter_stock_type: "Filter Stock Type",
      all_stock_types: "All Stock Types",
    },
    // Admin Orders
    admin_orders: {
      status: "Status",
      update: "Update",
      no_orders: "No orders found",
      total_transactions: "Total Transactions",
      export_per_product: "Export per Product",
      search_placeholder_v2: "Search Trans/Customer...",
      table: {
        transaction: "Transaction",
        customer: "Customer",
        total: "Total",
        total_paid: "Total Paid",
        status: "Status",
        actions: "Actions",
      },
      items_count: "{count} items purchased",
      modal: {
        customer_info: "Customer Info",
        summary: "Summary",
        date: "Date",
        payment_status: "Payment Status",
        shipping_status: "Shipping Status",
        grand_total: "Grand Total",
        items_purchased: "Items Purchased",
        installments: "Installments / Payments",
        no_payments: "No payments recorded yet.",
        record_payment: "Record New Payment",
        nominal: "Nominal",
        method: "Method",
        notes: "Notes (Optional)",
        add_payment_btn: "Add Payment",
        success_add_payment: "Installment added successfully",
        view_proof: "View Proof",
        customer_notes: "Customer Notes",
        shipping_settings: "Shipping Setup",
        courier: "Courier",
        awb: "Tracking No (AWB)",
        shipping_notes: "Shipping Notes",
        save_shipping: "Save & Ship Order",
        shipping_success: "Shipping tracking saved successfully",
      }
    },
    // Admin Brands
    admin_brands: {
      add_brand: "Add Brand",
      no_desc: "No description provided.",
      manage_products: "Manage Products",
      edit_brand: "Edit Brand",
      new_brand: "New Brand",
      save_changes: "Save Changes",
      update_btn: "Update Brand",
      create_btn: "Create Brand",
    },
    // Admin Rekenings
    admin_rekenings: {
      title: "Account Management",
      add_button: "Add Account",
      bank_name: "Bank Name",
      account_number: "Account Number",
      account_holder: "Card Holder Name",
      status: "Status",
      edit_title: "Edit Account",
      new_title: "New Account",
      placeholder_bank: "BCA / Mandiri / BSI",
      updated: "Account updated!",
      created: "Account created!",
      update_btn: "Update Account",
      create_btn: "Create Account",
    },
    // Admin Customers
    admin_customers: {
      title: "Customers & Partners",
      add_button: "Add Customer",
      no_customers: "No customers found.",
      name: "Name",
      type: "Type",
      contact: "Contact",
      status: "Status",
      actions: "Actions",
      edit_title: "Edit Customer",
      new_title: "New Customer",
      phone: "Phone",
      social_account: "Social Account (IG/Tiktok)",
      address: "Address / City",
      retail: "Customer (Retail)",
      updated: "Customer updated!",
      created: "Customer created!",
      deleted: "Customer deleted!",
      update_btn: "Update Customer",
      create_btn: "Create Customer",
    },
    // Admin Reports
    admin_reports: {
      title: "Reports & Analytics",
      tabs: {
        po_close: "PO Close Report",
        omset: "Omset Summary",
        export: "Export Data",
      },
      po_close_title: "Pre-Order Closing",
      po_close_desc: "Summary of orders for products closing on a specific date",
      omset_title: "Monthly Omset Summary",
      omset_desc: "Revenue aggregation by month",
      export_title: "Export Data",
      export_desc: "Download a full comprehensive Excel (.xlsx) file containing all Pre-Order transactions and details.",
      download_btn: "Download PO Transactions (Excel)",
      table: {
        product_name: "Product Name",
        total_qty: "Total Qty",
        transactions: "Transactions",
        omset: "Omset",
        month: "Month",
        discount: "Discount",
        grand_total: "Grand Total",
        type: "Order Type",
        preorder: "Pre-Order (PO)",
        ready_stock: "Ready Stock",
      },
      no_data_po: "No PO closing data for this date",
      no_data_omset: "No omset data found for {year}",
    },
    // Admin Users
    admin_users: {
      search_placeholder: "Search by name or email...",
      user: "User",
      role: "Role",
      joined: "Joined",
      update_role: "Update Role",
      no_users: "No users found",
      actions: "Actions",
      confirm_delete: "Delete this user?",
      deleted: "User deleted successfully",
    },
    // Admin Settings
    admin_settings: {
      config_title: "White-Label Configuration",
      store_name: "Store Name",
      primary_color: "Primary Color",
      secondary_color: "Secondary Color",
      store_desc: "Store Description",
      save_btn: "Save Settings",
      saving: "Saving...",
      rs_timeout: "Ready Stock Payment Timeout (Hours)",
      po_timeout: "Pre-Order Payment Timeout (Hours)",
    },
    // Product Detail
    product_detail: {
      preorder_info: "PreOrder Information",
      closing_date: "Closing Date",
      delivery_est: "Estimated Delivery",
      size: "Size",
      color: "Color",
      quantity: "Quantity",
      in_stock: "in stock",
      add_to_cart: "Add to Cart",
      buy_now: "Buy Now",
      reviews: "Customer Reviews",
      out_of_5: "out of 5",
      write_review: "Write a Review",
      your_rating: "Your Rating",
      share_experience: "Share your experience with this product...",
      submit_review: "Submit Review",
      submitting: "Submitting...",
      no_reviews: "No reviews yet. Be the first to review!",
      loading: "Loading product...",
    },
    // Orders Page
    orders: {
      title: "My Orders",
      no_orders: "No orders placed yet.",
      transaction: "Transaction",
      status_pending: "Pending Payment",
      status_paid: "Paid",
      status_processing: "Waiting for Shipment",
      status_shipped: "Shipping",
      status_completed: "Completed",
      status_preorder: "PreOrder",
      status_awaiting_settlement: "Awaiting Settlement",
      status_cancelled: "Cancelled",
      success_upload: "Payment proof uploaded! Status updated to Paid.",
      upload_proof: "Upload Payment Proof",
      upload_desc: "Transfer to our bank account and upload the receipt",
      uploading: "Uploading...",
      upload_btn: "Upload Receipt",
      proof_uploaded: "Payment proof uploaded",
      view_proof: "View",
      cancel_order: "Cancel Order",
      cancel_confirm: "Are you sure you want to cancel this order?",
      cancel_success: "Order cancelled successfully",
      cancelling: "Cancelling...",
      back_to_list: "Back to Orders List",
      not_found: "Order not found.",
      order_id: "Order",
      po_closing_in: "PO closed in",
      unit_day: "d",
      unit_hour: "h",
      unit_minute: "m",
      unit_second: "s",
      transaction: "Transaction",
      grand_total: "Grand Total",
      view_detail: "View Details",
      search_placeholder: "Search Order ID or products...",
      sort_by: "Sort By",
      newest: "Newest",
      oldest: "Oldest",
      name_asc: "Product Name (A-Z)",
      name_desc: "Product Name (Z-A)",
    },
    order_detail: {
      status_title: "Order Status",
      items_title: "Product List",
      payment_title: "Payment Instructions",
      shipping_title: "Shipping Address",
      billing_summary: "Billing Summary",
      paid: "Paid",
      remaining: "Remaining Balance",
      dp_required: "DP Required",
      po_notice: "Pre-Order: Please pay DP first",
      rs_notice: "Please Transfer Immediately",
      due_date: "Due Date",
      copy_rek: "Account number copied!",
      upload_proof_btn: "Upload Payment Proof",
      uploading: "Uploading...",
      proof_sent: "Proof Sent",
      proof_desc: "Thank you. We have received your payment proof and it is currently being verified.",
      view_attachment: "View Attachment",
      shipping_desc_po: "As per PO procedure, you can set your address at your convenience now without any rush! 🥳",
      shipping_update_desc: "Please update your address if there are any changes before shipping.",
      recipient_name: "Recipient Name",
      phone_number: "Phone Number",
      full_address: "Full Address",
      save_address: "Save Address",
      cancel: "Cancel",
      shipped_to: "Shipped to",
      edit: "Edit",
      cancel_order: "Cancel Order",
      waiting_verification: "Waiting for Admin Verification",
      fill_address: "Complete Shipping Address",
      order_processing: "Order being Processed",
      confirm_dp: "Confirm DP Payment",
      confirm_settlement: "Confirm Settlement",
      confirm_full: "Confirm Full Payment",
      payment_history: "Payment Confirmation History",
      conf_submitted: "Confirmation submitted, waiting for Admin verification.",
      conf_verified: "Verified",
      conf_rejected: "Rejected",
      conf_pending: "Pending",
      payment_proof_label: "Payment Proof",
      shipping_info: "Track Shipment",
      courier: "Courier",
      awb: "Tracking Number",
      copied: "Copied!",
    },
    // Wishlist Page
    wishlist: {
      title: "My Wishlist",
      empty: "Your wishlist is empty",
      browse: "Browse Products",
    },
    // Login/Register Page
    auth: {
      welcome_back: "Welcome Back",
      create_account: "Create Account",
      sign_in_desc: "Sign in to continue shopping",
      join_today: "Join Haniyah Gallery today",
      full_name: "Full Name",
      email: "Email",
      password: "Password",
      account_type: "Account Type",
      retail_customer: "Retail Customer",
      reseller: "Reseller",
      agen: "Agent",
      mitra: "Partner",
      reseller_agent: "Reseller / Agent",
      sign_in_btn: "Sign In",
      sign_up_btn: "Create Account",
      please_wait: "Please wait...",
      or: "or",
      google_continue: "Continue with Google",
      no_account: "Don't have an account?",
      have_account: "Already have an account?",
      sign_up_link: "Sign Up",
      sign_in_link: "Sign In",
      welcome_msg: "Welcome back!",
      account_created: "Account created!",
    },
    // Product Card
    product_card: {
      login_required: "Please login to add to wishlist",
      added: "Added to wishlist",
      removed: "Removed from wishlist",
      reseller: "Reseller",
      closes: "Closes",
    },
    // Notifications
    notifications: {
      title: "Notifications",
      mark_all_read: "Mark all read",
      no_notifs: "No notifications",
    },
    // Admin Master Variants
    admin_master: {
      title: "Variant Master Data",
      tab_styles: "Styles",
      tab_colors: "Colors",
      tab_sizes: "Sizes",
      add_btn: "Add",
      adding: "Adding...",
      name: "Name",
      hex_code: "Hex Code",
      sort_order: "Sort Order",
      confirm_delete: "Delete this item?",
      deleted: "Deleted successfully",
      added: "Added successfully",
      no_data: "No data yet",
      placeholder_style: "New style name...",
      placeholder_color: "New color name...",
      placeholder_size: "New size name...",
    },
    // Landing Page
    landing: {
      hero_tag: "Haniyah Gallery",
      hero_headline: "Elegance in Every Thread",
      hero_desc: "Curated muslim fashion collections from trusted fashion brands for you and your family.",
      hero_cta: "Explore Collection",
      hero_cta2: "Become a Partner",
      values_tag: "Why Haniyah Gallery",
      values_title: "A Trusted Fashion Partner",
      value_1_title: "Trusted / Amanah",
      value_1_desc: "Established since 2019.",
      value_2_title: "Multi-Brand Distributor",
      value_2_desc: "Selling more than 100 fashion brands.",
      value_3_title: "Neat & Secure Packaging",
      value_3_desc: "Every order is processed with neat, secure packaging and ready to ship to customers.",
      value_4_title: "Reseller Support",
      value_4_desc: "Supporting resellers and dropshippers with curated products and reliable shipping.",
      brands_tag: "Trusted by Many Brands",
      brands_title: "Our Brand Partners",
      brands_desc_prefix: "Trusted by",
      brands_desc_suffix: "curated brand partners that strengthen our credibility and reach.",
      brands_empty: "Brand partner logos will appear here once brand data is available.",
      brands_cta: "View All Brands",
      brands_partner_cta: "Join Our Partners",
      featured_tag: "Best Picks",
      featured_title: "Featured Collection",
      featured_desc: "Hand-picked products that are favorites among our customers.",
      featured_cta: "View All Collections",
      featured_fallback_1: "Sage Premium Gamis",
      featured_fallback_2: "Elegant Couple Set",
      featured_fallback_3: "Exclusive Voal Hijab",
      featured_fallback_4: "Harmoni Family Set",
      preorder_tag: "Reseller Opportunity",
      preorder_title: "Start earning from home…",
      preorder_desc: "Join Haniyah Gallery as a Reseller 🤍\nNo need to stock a lot of products, no need to own a store ✨\nAll you need is intention, a phone, and the spirit to learn selling 🥰",
      preorder_cta: "Join as Reseller",
      preorder_benefit_heading: "Why join Haniyah Gallery?",
      preorder_benefit_1: "FREE registration",
      preorder_benefit_2: "Sell from home",
      preorder_benefit_3: "Free beautiful catalog, ready to post",
      preorder_benefit_4: "Free access to our selling support group",
      preorder_benefit_5: "Discounts up to 30%",
      preorder_benefit_6: "Sales cashback & rewards",
      preorder_benefit_7: "Sell 100+ muslimah fashion brands",
      preorder_suitable_heading: "Perfect for:",
      preorder_suitable_1: "Moms at home",
      preorder_suitable_2: "College students",
      preorder_suitable_3: "Employees looking for extra income",
      preorder_suitable_4: "Anyone who wants to slowly start a business",
      preorder_closing_note: "💌 Learn step by step, hopefully it becomes a path of blessing",
      reseller_tag: "Business Opportunity",
      reseller_title: "Become a Haniyah Gallery Partner",
      reseller_desc: "Join our reseller network and build your own muslim fashion business with our full support.",
      reseller_cta: "Register as Partner",
      reseller_benefit_1: "Competitive reseller pricing",
      reseller_benefit_2: "Ready-to-use marketing materials",
      reseller_benefit_3: "Business support & guidance",
      reseller_benefit_4: "No large minimum orders",
      packaging_tag: "Shipping",
      packaging_title: "Neat Packaging, Ready to Ship to Customers",
      packaging_desc: "Every order is processed with neat and secure packaging.",
      packaging_benefit_1: "Secure and neat packaging",
      packaging_benefit_2: "Ready to support resellers",
      packaging_benefit_3: "Supports dropship shipping",
      packaging_cta: "Become a Partner",
      packaging_main_alt: "Neat Haniyah Gallery shipping packaging ready to ship",
      packaging_detail_alt: "Haniyah Gallery reseller shipping package detail",
      packaging_stack_alt: "Stack of Haniyah Gallery packages ready to ship",
      packaging_shipment_alt: "Haniyah Gallery shipping packages ready for delivery",
      testimonial_tag: "Testimonials",
      testimonial_title: "What They Say About Us",
      testimonial_1_name: "Siti Aminah",
      testimonial_1_loc: "Jakarta",
      testimonial_1_text: "The material is so breathable and the stitching is immaculate. I've reordered 3 times already. My kids love wearing the family sets too!",
      testimonial_2_name: "Dewi Rahmawati",
      testimonial_2_loc: "Surabaya",
      testimonial_2_text: "As a reseller, the support from Haniyah Gallery has been incredible. Products sell easily because the quality speaks for itself.",
      testimonial_3_name: "Nur Fadilah",
      testimonial_3_loc: "Bandung",
      testimonial_3_text: "The designs are elegant and unique. Perfect for both formal occasions and everyday wear. Shipping is fast and secure too.",
      closing_title: "Find Your Dream Collection",
      closing_desc: "Explore our range of premium muslim fashion designed to accompany every special moment of yours.",
      closing_cta: "Shop Now",
    }
  }
};

export default translations;
